module.exports = __webpack_public_path__ + "img/chen-yuxia-author.6b55d73f.jpg";